import joinClassNames from './joinClassNames.js'

/**
 * Bordered panel with header divider — agent health, activity, infra cards.
 *
 * @param {{
 *   title: React.ReactNode
 *   children: React.ReactNode
 *   headerAction?: React.ReactNode
 *   className?: string
 *   bodyClassName?: string
 *   paddedBody?: boolean
 *   layout?: 'full' | 'readable' | 'compact' | 'wide'
 * }} props
 *
 * `layout` applies analytics width modifiers when rendered inside `.analytics-dashboard`:
 * - full (default) — span dashboard width (performance summary, tables, KPI grids)
 * - compact — narrow label/value panels (e.g. Activity sidebar card)
 * - readable — optional mid-width cap for prose-heavy panels
 */
export default function DataPanelCard({
  title,
  children,
  headerAction,
  className = '',
  bodyClassName = '',
  paddedBody = false,
  layout = 'full',
  id,
  'aria-label': ariaLabel,
}) {
  const layoutClass = layout === 'compact'
    ? 'analytics-panel--compact'
    : layout === 'readable'
      ? 'analytics-panel--layout-readable'
      : ''

  return (
    <section
      id={id}
      className={joinClassNames('data-panel-card', layoutClass, className)}
      aria-label={ariaLabel}
    >
      <header className="data-panel-card__header">
        <div className="data-panel-card__title">{title}</div>
        {headerAction}
      </header>
      <div
        className={joinClassNames(
          'data-panel-card__body',
          paddedBody && 'data-panel-card__body--padded',
          bodyClassName,
        )}
      >
        {children}
      </div>
    </section>
  )
}
